import axios, { type AxiosResponse } from "axios";
import { TrackingItemSchema, TrackingListItemSchema } from "@/schemas/index";
import type {
  TrackingItemType,
  ShippingItemType,
  TrackingListItemType,
} from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceTrackingApi {
  fetchTrackingItem: (
    shippingId: ShippingItemType["Id"],
  ) => Promise<TrackingItemType | null>;
  fetchTrackingListItems: () => Promise<TrackingListItemType[]>;
}

export const serviceTrackingApi: ServiceTrackingApi = {
  fetchTrackingItem: (shippingId) => {
    return axios
      .get(`${env.services.portal}/tracking/${shippingId}`)
      .then((response: AxiosResponse<unknown>) => {
        return TrackingItemSchema.parse(response?.data);
      });
  },
  fetchTrackingListItems: () => {
    return axios
      .get(`${env.services.portal}/tracking`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            TrackingListItemSchema.parse(item),
          ) || []
        );
      });
  },
};
